import { useState } from "react";
import { useSignUpEmailPassword } from "@nhost/react";
import { Link, Navigate } from "react-router-dom";



const SignUp = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const {
    signUpEmailPassword,
    isLoading,
    isSuccess,
    needsEmailVerification,
    isError,
    error,
  } = useSignUpEmailPassword();

  const handleOnSubmit = (e) => {
    e.preventDefault();

    signUpEmailPassword(email, password, {
      displayName: `${firstName} ${lastName}`.trim(),
      metadata: {
        firstName,
        lastName,
      },
    });
  };

  if (isSuccess) {
    return <Navigate to="/" replace={true} />;
  }

  const disableForm = isLoading || needsEmailVerification;

  return (
    <div className="flex-col  mt-11 bg-neutral-400  w-96 ml-96 h-96 shadow-md rounded-l-lg shadow-black    ">
      <div className="flex-col  mt-11 bg-slate-700 ">
        {needsEmailVerification ? (
          <p>
            Please check your mailbox and follow the verification link to verify
            your email.
          </p>
        ) : (
          <form onSubmit={handleOnSubmit}>
            <div className="flex flex-col pt-5">
              <h2 className=" mx-10 mb-5 font-medium text-lime-400  ">
                {" "}
                Enter FirstName
              </h2>
              <input
                placeholder="First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                disabled={disableForm}
                required
              />
              <h2 className=" mx-10 mb-5 font-medium text-lime-400  ">
                {" "}
                Enter LastName
              </h2>
              <input
                placeholder="Last name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                disabled={disableForm}
                required
              />
            </div>
            <div className="flex flex-col">
              <h2 className=" mx-10 mb-5 font-medium text-lime-400  ">
                {" "}
                Enter Email
              </h2>
              <input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={disableForm}
                required
              />
              <h2 className=" mx-10 mb-5 font-medium text-lime-400  ">
                {" "}
                Enter Password
              </h2>
              <input
                type="password"
                placeholder="Create password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={disableForm}
                required
              />
            </div>

            <button type="submit" disabled={disableForm}>
              {isLoading ? "loading" : "Create account"}
            </button>

            {isError ? <p>{error?.message}</p> : null}
          </form>
        )}
      </div>

      <p>
        Already have an account? <Link className="text-blue-500 " to="/sign-in">Sign in</Link>
      </p>
    </div>
  );
};

export default SignUp;
